import { useCallback, useEffect, useState } from 'react'
import { SEQHandler } from '../api/apiHandler'

interface SeqLogParams {
    message: string
    level?: 'Error' | 'Warning' | 'Information' | 'Debug'
    error?: any
}

function useSeqLogger() {
    const [loggerUrl, setLoggerUrl] = useState<string>('')
    const [loggerSystem, setLoggerSystem] = useState<string>('')
    const [loggerKey, setLoggerKey] = useState<string>('')

    useEffect(() => {
        // Hämta loggerUrl från config.json
        fetch('/config.json')
            .then(response => response.json())
            .then(data => {
                if (data.loggerUrl) setLoggerUrl(data.loggerUrl)
                if (data.loggerSystem) setLoggerSystem(data.loggerSystem)
                if (data.loggerKey) setLoggerKey(data.loggerKey)
            })
            .catch(err => {
                console.error('Failed to load config.json:', err)
            })
    }, [])

    const logToSeq = useCallback(
        ({ message, level = 'Information', error }: SeqLogParams) => {
            if (!loggerUrl) {
                console.warn('Logger URL not configured')
                return
            }

            const currentUrl = window.location.href
            const errorDetails = error ? ` - ${error?.statusText || error?.message || JSON.stringify(error)}` : ''
            const logMessage = `${message}${errorDetails} | URL: ${currentUrl}`

            SEQHandler({
                submitData: {
                    system: loggerSystem || 'name not-set for specific e-service',
                    message: logMessage,
                    level,
                },
                url: loggerUrl,
                apiKey: loggerKey,
            }).catch(err => {
                console.error('Failed to log to SEQ:', err)
            })
        },
        [loggerUrl, loggerSystem, loggerKey]
    )

    return { logToSeq, isConfigured: !!loggerUrl }
}

export default useSeqLogger
